/**
 *  Gets cookie values from the document and parses them to
 */
export function cookies() {
  return Object.fromEntries(
    document.cookie.split('; ').map((x) => x.split(/=(.+)/))
  );
}

/**
 * Get a cookie of the given name as a raw string
 * @param {string} cookieName
 * @returns {Object} String containing raw cookie value, empty string if no cookie found
 */
export function getCookie(cookieName) {
  return cookies()[cookieName] ?? '';
}

/**
 * Get a cookie of the given name as a key-value pair object
 * @param {string} cookieName
 * @returns {Object} Object containing parsed cookie key/value pairs, empty object if no cookie found
 */
export function getCookieObject(cookieName) {
  const jar = cookies();

  if (!jar[cookieName]) return {};

  return Object.fromEntries(
    jar[cookieName].split('&').map((x) => x.split('='))
  );
}

/**
 * Parse encoded cookie value
 * @param {string} cookieValue
 * @returns {string} Default empty string
 */
export function parseCookieValue(cookieValue) {
  if (!cookieValue) return '';
  return decodeURIComponent(cookieValue.replace(/\+/g, ' '));
}
